export const ENV: any = {
    name: 'dev',
    thumbnailerUrl: 'https://wtz3nggkxb.execute-api.eu-west-1.amazonaws.com/dev/thumb'
};

export const REST = {
    HOST: 'https://vas-api.ironcode.io',
    ENDPOINT: '/api/v1'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts